import { MOMENT_TIME_FORMAT } from '../../constants/date_format';
import moment from 'moment';

export class ExcelExport {
    term: any;
    change: any;
    action: any;
    crn: any;
    course: any;
    block: any;
    type: any;
    fromDay: any;
    fromTime: any;
    fromRoom: any;
    toDay: any;
    toTime: any;
    toRoom: any;
    from: any;
    to: any;
    bannerID: any;
    comments: any;

    constructor(term, change, action, crn, course, block, type, fromDay, timeInFrom, timeOutFrom, fromRoom, toDay, timeInTo, timeOutTo, toRoom, from, to, bannerID, comments) {
        this.term = term;
        this.change = change;
        this.action = action;
        this.crn = crn;
        this.course = course;
        this.block = block;
        this.type = type;
        this.fromDay = fromDay;
        this.fromTime = this.getFromTime(timeInFrom, timeOutFrom);
        this.fromRoom = fromRoom;
        this.toDay = toDay;
        this.toTime = this.getFromTime(timeInTo, timeOutTo);
        this.toRoom = toRoom;
        this.from = from;
        this.to = to;
        this.bannerID = bannerID;
        this.comments = comments;
    }

    getFromTime = (timeIn, timeOut) => {
        let timeCode = this.getTimeCodeForExport(timeIn).toString();

        const timeInUTC = moment.utc(timeIn, 'HH:mm');
        const timeOutUTC = moment.utc(timeOut, 'HH:mm');
        const result = timeOutUTC.subtract(timeInUTC.hours(), 'hours');
        const hours = result.hours();

        if (hours > 1) {
            timeCode = timeCode + '/' + (parseInt(timeCode) + 1).toString();
        }

        return timeCode;
    };

    getTimeCodeForExport = (time) => {
        const timeStr = moment(time, MOMENT_TIME_FORMAT).clone().format(MOMENT_TIME_FORMAT);
        switch (timeStr) {
            case '07:30:00':
                return 1;
            case '08:30:00':
                return 2;
            case '09:30:00':
                return 3;
            case '10:30:00':
                return 4;
            case '11:30:00':
                return 5;
            case '12:30:00':
                return 6;
            case '13:30:00':
                return 7;
            case '14:30:00':
                return 8;
            case '15:30:00':
                return 9;
            case '16:30:00':
                return 10;
            default:
                return ''; //between the Grids ex. 9 or 10
        }
    };
}
